module.exports = "<div class=\"container top\">\n  <div>\n    <p class=\"images\" *ngFor=\"let screenshot of (project | async)?.screenshots\"><img  src=\"{{screenshot}}\" alt=\"{{(project | async)?.name}}\"></p>\n    <p><b>{{(project | async)?.name}}</b></p>\n    <p>{{(project | async)?.description}}</p>\n    <p>{{(project | async)?.githubLink}}</p>\n    <p>{{(project | async)?.projectLink}}</p>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/project-details/project-details.component.html
// module id = ../../../../../src/app/project-details/project-details.component.html
// module chunks = main